export default {
  default: {
    menu: {
      downloadPdf: 'Download PDF',
    },
    importedFrom: 'Imported from {global.integrationPlatform.title} - #{externalId}',
  },
}
